import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-06cc2b28"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "insurance-info-block"
}
const _hoisted_2 = {
  key: 1,
  class: "faq-block"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_text_formatter = _resolveComponent("text-formatter")!
  const _component_base_card = _resolveComponent("base-card")!
  const _component_faq_group = _resolveComponent("faq-group")!
  const _component_main_container_shell = _resolveComponent("main-container-shell")!

  return (_openBlock(), _createBlock(_component_main_container_shell, { classes: ['container'] }, {
    default: _withCtx(() => [
      (_ctx.hasInformation)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_base_card, null, {
              default: _withCtx(() => [
                _createVNode(_component_text_formatter, { content: _ctx.information }, null, 8, ["content"])
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      (_ctx.hasFaqItems)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.frequentlyAskedQuestions, (group) => {
              return (_openBlock(), _createBlock(_component_faq_group, {
                key: group.title,
                group: group
              }, null, 8, ["group"]))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}